import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { TranslateService } from '@services/translate/translate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import * as _ from 'lodash';
import { MessengerService } from '@services/messenger/messenger.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { Models } from '@ibexfusion/models';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { EditMediaComponent } from '../dynamic-content/dynamic-content-edit/components/edit-media/edit-media.component';
import { PackageService } from '@services/packages/package.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { AssetsComponent } from '../../components/assets/assets.component';
import { FileAssetsService } from '@services/assets/file-assets.service';
import { VideoAssetsService } from '@services/assets/video-assets.service';
import { EditAssetComponent } from '../dynamic-content/dynamic-content-edit/components/edit-asset/edit-asset.component';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss'],
    providers: [DynamicContentEntranceService, PackageInstalledAppsService, DynamicContentService, ImageAssetsService, FileAssetsService, VideoAssetsService],
    standalone: false
})
export class ResourcesComponent implements OnInit {
  @ViewChild(AssetsComponent) assetsComponent!: AssetsComponent;
  public pageActions: PageAction[];

  public pages = [];
  public currentPage: any;
  public dynamicContentEntrances: any[] = [];
  public packageIds;
  public tabIndex;
  public data: any = [];
  private children: any = {};
  private dynamicContentQuery;
  public isLoading = false;
  selectedTab = 0;
  menu;
  selectedFolderId;
  private currentLanguage = 'de';
  languages;
  packageLang;
  dynamicContent;
  pak: Models.Package;
  packages: Models.Package[];
  apps: Models.PackageInstalledApp[];
  activeContents;

  constructor(
    public dynamicContentService: DynamicContentService, public entranceService: DynamicContentEntranceService, private router: Router, private ts: TranslateService,
    private appService: PackageInstalledAppsService, private snackbar: SnackbarService, private activatedRoute: ActivatedRoute, private videoAssetService: VideoAssetsService,
    private packageService: PackageService, private dialog: MatDialog, private imageAssetsService: ImageAssetsService, private fileAssetService: FileAssetsService,
    private messengerService: MessengerService
  ) {
    this.selectedTab = this.activatedRoute.snapshot.queryParams['tab'] ? +this.activatedRoute.snapshot.queryParams['tab'] : 0;
    this.selectedFolderId = this.activatedRoute.snapshot.queryParams['folder'];
    this.packageIds = this.activatedRoute.snapshot.params['packageId'];
    if (this.packageIds) {
      window['forcePackage'] = this.packageIds;
    }
    this.getLang();
  }

  async init() {
    if (!this.activatedRoute.snapshot.params['packageId']) {
      this.snackbar.open('Sorry, wrong routing');
      this.router.navigate(['dynamic-content-entrances']);
      return;
    }
    this.selectedTab = this.activatedRoute.snapshot.queryParams['tab'] ? +this.activatedRoute.snapshot.queryParams['tab'] : 0;
    this.packageIds = this.activatedRoute.snapshot.params['packageId'].split(',');
    this.packages = (await this.packageService.find(0, 100, { _id: { $in: this.packageIds } })).data || [];
    if (this.packageIds) {
      window['forcePackage'] = this.packageIds[0];
    }
    this.messengerService.$activeContents.subscribe(contents => {
      if (JSON.stringify(contents) === JSON.stringify(this.activeContents) || !contents) {
        return;
      }
      this.activeContents = contents;
      this.initContent(contents);
    });
  }

  async initContent(contents) {
    this.isLoading = true;
    if (!this.messengerService.getOrganisation()) {
      return;
    }
    const query: any = {};
    this.pak = (await this.packageService.find(0, 1, { _id: { $in: this.packageIds } }))?.data?.[0];
    if (!!contents?.length) {
      query['_id'] = { $in: contents.map(el => el['dynamicContentEntrance_Id']) };
    } else {
      const apps = (await this.appService.find(0, this.pak?.installedAppIds?.length, { _id: { $in: this.packages.map(pak => pak.installedAppIds).flat() } }))?.data;
      this.apps = apps.filter(app => this.pak.compositionIds.includes(app.compositionId));
      query['_id'] = { $in: this.apps.map(app => app.dynamicContentEntranceId).filter(el => !!el) };
    }
    this.getDynamicContentEntrances(query);
  }

  async ngOnInit() {
    const translation = this.ts.get('resources');
    this.pages = [
      { title: translation.images, type: 'image', content: [] }, { title: translation.documents, type: 'file', content: [] },
      { title: translation.videos, type: 'video', content: [] }, { title: translation.media, type: 'media', content: [] }
    ];
    this.currentPage = this.selectedTab ? this.pages[+this.selectedTab] : this.pages[0];
    this.init();
  }

  async getLang() {
    const myPackage = await this.packageService.get(this.packageIds);
    this.languages = myPackage.availableLanguagesCached;
    this.packageLang = myPackage.masterLanguageCached;
  }

  tabChange(index) {
    this.selectedTab = index;
    this.currentPage = this.pages[index];
    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTab, folder: this.selectedFolderId } });
  }

  public async onSelect($event) {
    const assetService: any = $event.type === 'file' ? this.fileAssetService : ($event.type === 'video' ? this.videoAssetService : this.imageAssetsService);
    let boundAsset = await assetService.get($event.asset._id);
    const config = {
      width: '875px', height: 'auto', panelClass: 'edit-media-modal',
      data: { asset: boundAsset, availableLanguages: this.languages, packageLang: this.packageLang, isInContent: $event.asset.isInContent, page: 'library', type: $event.type }
    }
    if ($event.type === 'image') {
      config['dataType'] = this.dynamicContent ? this.dynamicContent.type : 'all';
      await this.dialog.open(EditMediaComponent, config).afterClosed().toPromise()
    } else {
      await this.dialog.open(EditAssetComponent, config).afterClosed().toPromise()
    }
    boundAsset = await assetService.get($event.asset._id);
    this.assetsComponent.updateAssets(boundAsset);
  }

  public async getDynamicContentEntrances(query) {
    try {
      const result = await this.entranceService.findAssigned(0, 100, query, query.OwnerOrganisationID ? { packageIds: this.packageIds } : null);
      this.dynamicContentEntrances = result?.entrances || [];
      this.dynamicContentEntrances.map(entrance => {
        entrance['translations'].map(translation => {
          if (translation.language === this.currentLanguage) {
            entrance.title = translation.appTitle
          }
        });
      });
      const roles = new Set(this.messengerService.$activeRoles.getValue()?.map((role: any) => role.roleName));
      if (!(roles.size === 1 && roles.has('contentAuthor'))) {
        this.dynamicContentEntrances.unshift({ _id: 'all', title: 'Alle' });
      }
      this.openTab(this.selectedFolderId || this.dynamicContentEntrances[0]._id);
      this.isLoading = false;
    } catch (err) {
      console.error('Error: ', err.message);
      this.isLoading = false;
    }
  }


  openTab(id) {
    this.isLoading = true;
    this.tabIndex = this.dynamicContentEntrances.findIndex(el => el._id === id);
    this.selectedFolderId = id !== 'all' ? id : '';
    this.dynamicContent = id === 'all' ? null : this.dynamicContentEntrances.find(el => el._id === id);

    if (this.selectedFolderId) {
      const entrance = this.dynamicContentEntrances.find(el => el._id === id);
      this.dynamicContentQuery = { entranceId: entrance._id, withSubs: true };
      this.getContent();
    } else {
      this.pages.forEach(el => {
        el.content = [];
        el.showAll = true;
      });
      this.data = [];
      this.isLoading = false;
      if (!this.router.url.startsWith('/dashboard')) {
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTab, folder: this.selectedFolderId } });
      }
    }
  }


  public async getContent() {
    const tree = [];
    if (!this.dynamicContentQuery) {
      this.data = [];
      this.isLoading = false;
      return;
    }
    const result = await this.dynamicContentService.find(0, 1000, this.dynamicContentQuery);
    if (!result?.data) {
      this.data = tree;
      this.isLoading = false;
      return;
    }
    result.children?.forEach(child => {
      const item = new Models.DynamicContent();
      item.populateFromJSON(child);
      this.children[child._id] = item;
    });
    result.data = result.data.filter(element => !element.content?.date?.includes('Invalid'));
    result.data.map(async entry => {
      const treeItem = this.pushToTree(entry, 1);
      treeItem.data.parent = this.dynamicContentEntrances[this.tabIndex]._id;
      tree.push(treeItem);
    });
    this.data = tree;
    this.pages.forEach(el => {
      el.content = [];
      el.showAll = false;
    });
    this.findMedia(this.data);
    setTimeout(() => {
      this.isLoading = false;
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { tab: this.selectedTab, folder: this.selectedFolderId }
      });
    }, 500);
  }


  findMedia(data) {
    data.forEach(item => {
      const { dataFiles, mediaFiles } = item.data;
      if (dataFiles?.length) {
        this.pages[1].content = this.pages[1].content.concat(dataFiles);
      }
      mediaFiles?.forEach(media => {
        if (media.mimeType.includes('image')) {
          this.pages[0].content = this.pages[0].content.concat(media);
        } else if (media.mimeType.includes('video')) {
          this.pages[2].content = this.pages[2].content.concat(media);
        }
      });

      if (item.children?.length) {
        this.findMedia(item.children);
      }
    });
  }


  private pushToTree(item, level): any {
    level++;
    const children = (item.children || []).map(id => {
      if (this.children[id]) {
        let subEntry = this.pushToTree(_.cloneDeep(this.children[id]), level);
        subEntry.data.parent = item._id;
        return subEntry;
      } else {
        console.warn(id)
      }
    });
    children.sort((a, b) => a.data.order - b.data.order);
    return { data: { ...item, translation: [], level, children: children.map(child => child.data) }, children };
  }
}
